import { globalQueryKeys } from '../global-query-keys';

export const WARRANTIES_API_URL = 'ui/organization/warranties';

export const warrantiesQueryKeys = {
  global: [...globalQueryKeys.warranties],
  all: () => [...warrantiesQueryKeys.global, WARRANTIES_API_URL],
};
